import service from '@services/cart/initializeCart';
import { errorAction, successfulAction } from '@shared/actions';
import { INIT_CART } from '@core/reducers/cart/actionTypes';
import getIsInitializingCart from '@core/reducers/cart/selectors/getIsInitializingCart';
import isOutOfDeliveryError from '@utils/cart/isOutOfDeliveryError';
import { sessionCache } from '@services/cache';
import { DELIVERY_FEE } from '../constants';

export const type = INIT_CART;

const initializeCart = ({
  restaurantId,
  location,
  fromOrderId,
  userApplication,
  isPickup,
  businessType,
}) => async (dispatch, getState, axios) => {
  try {
    const state = getState();
    const isInitializingCart = getIsInitializingCart(state);

    if (isInitializingCart) return true;

    dispatch({ type, payload: fromOrderId });

    const initialData = { restaurantId, location, fromOrderId, businessType };
    if (userApplication) initialData.userApplication = userApplication;
    if (isPickup) initialData.pickUp = true;

    const { success, data, error } = await service({
      axios,
      ...initialData,
    });

    if (success) {
      const plusSettings = data.plus?.discounts?.find(
        discount => discount.type === DELIVERY_FEE,
      );
      sessionCache.set(`cart_plus_${data.guid}`, plusSettings);
      dispatch(successfulAction({ type, payload: data }));
    } else {
      const outOfDeliveryError = isOutOfDeliveryError(error);
      dispatch(
        errorAction({
          type,
          error,
          mute: outOfDeliveryError,
          errorMessage: outOfDeliveryError
            ? 'El local no entrega en esta ubicación'
            : 'Error al crear el carrito',
        }),
      );
    }

    return success;
  } catch (error) {
    dispatch(
      errorAction({ type, error, errorMessage: 'Error al crear el carrito' }),
    );
    return false;
  }
};

export default initializeCart;
